// API Configuration
//
// In development VITE_API_URL is intentionally empty so that all requests use
// relative paths (e.g. "/auth/login") which are forwarded by the Vite dev
// proxy to the backend — avoiding CORS issues from cross-origin fetch.
//
// In production / test the CI pipeline sets VITE_API_URL to the full backend
// URL (e.g. "https://os-api.ai-build.com").
const backendPort = import.meta.env.BACKEND_PORT || '8081';
const envUrl: string | undefined = import.meta.env.VITE_API_URL;
export const API_BASE_URL = envUrl ?? `http://localhost:${backendPort}`;
export const API_TIMEOUT = 120000;
